var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AbstractTask from './abstract-task';
import qs from 'qs';
import streamSaver from 'streamsaver';
export default class AbstractDownloadTask extends AbstractTask {
    /**
     * Executes the request
     *
     * @returns
     */
    execute() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.downloadFile();
            const filename = this.generateFilename(response);
            yield this.streamFileToClient(response, filename);
        });
    }
    /**
     * Downloads the file from the URL
     *
     * @returns
     */
    downloadFile() {
        return __awaiter(this, void 0, void 0, function* () {
            // Generate the full URL including query string
            let url = this.baseUrl + this.url;
            if (Object.keys(this.params).length > 0) {
                url += `?${qs.stringify(this.params)}`;
            }
            // Make the request for the data
            return yield fetch(url, {
                method: 'GET',
                headers: this.headers,
            });
        });
    }
    /**
     * Streams the file to the client
     *
     * @param response
     * @param filename
     * @returns
     */
    streamFileToClient(response, filename) {
        return __awaiter(this, void 0, void 0, function* () {
            const readableStream = response.body;
            if (!readableStream) {
                return;
            }
            // Generate the output file stream
            const fileStream = streamSaver.createWriteStream(filename);
            // More optimised handling where supported
            if (window.WritableStream && readableStream.pipeTo) {
                return readableStream.pipeTo(fileStream);
            }
            // Fallback handling
            const writer = fileStream.getWriter();
            const reader = response.body.getReader();
            const pump = () => reader.read()
                .then(response => (response.done
                ? writer.close()
                : writer.write(response.value).then(pump)));
            pump();
        });
    }
    /**
     * Returns the base url
     */
    get baseUrl() {
        return '';
    }
    /**
     * Generates a filename from the response
     *
     * @param response
     * @returns
     */
    generateFilename(response) {
        var _a;
        // If a filename exists in the response headers, use that
        const contentDisposition = response.headers.get('Content-Disposition');
        if (contentDisposition) {
            return (_a = this.getFilenameFromHeaders(contentDisposition)) !== null && _a !== void 0 ? _a : this.filename;
        }
        // Otherwise use the local filename
        else {
            return this.filename;
        }
    }
    /**
     * Extracts the filename from the Content-Disposition header, if available
     *
     * See: https://stackoverflow.com/a/67994693
     *
     * @param disposition
     * @returns
     */
    getFilenameFromHeaders(disposition) {
        const utf8FilenameRegex = /filename\*=UTF-8''([\w%\-.]+)(?:; ?|$)/i;
        const asciiFilenameRegex = /^filename=(["']?)(.*?[^\\])\1(?:; ?|$)/i;
        let fileName = null;
        if (utf8FilenameRegex && utf8FilenameRegex.test(disposition)) {
            const matches = utf8FilenameRegex.exec(disposition);
            if (!matches) {
                return null;
            }
            fileName = decodeURIComponent(matches[1]);
        }
        else {
            const filenameStart = disposition.toLowerCase().indexOf('filename=');
            if (filenameStart >= 0) {
                const partialDisposition = disposition.slice(filenameStart);
                const matches = asciiFilenameRegex.exec(partialDisposition);
                if (matches !== null && matches[2]) {
                    fileName = matches[2];
                }
            }
        }
        return fileName;
    }
    /**
     * Returns the filename to use for the download
     */
    get filename() {
        var _a;
        return (_a = this.url.split(/[\\/]/).pop()) !== null && _a !== void 0 ? _a : this.url;
    }
}
//# sourceMappingURL=abstract-download-task.js.map